<template>
    <div class="show-img">
        <img :src="this.params.data.imageUrl" class="rounded w-full img-checkin cursor-pointer" @click="popupShowImage = true"/>
        <vs-popup class="holamundo"  title="Lorem ipsum dolor sit amet" :active.sync="popupShowImage" v-if="popupShowImage" id="popupShowImage">
            <img :src="this.params.data.imageUrl" class="showImg">
        </vs-popup>
    </div>
</template>
<script>
export default {
    name: 'CellRendererActions',
    data() {
        return {
            popupShowImage: false,
        }
    },
    methods: {}
}
</script>
<style scoped>

.show-img .img-checkin {
    display: block;
    height: auto;
    padding: 5px;
    width: 70px !important;
}

.show-img {
    position: relative
}
</style>

<style lang="scss">
.showImg {
    width: 567px;
    height: auto;
}

#popupShowImage {
    .vs-popup--header {
        display: none;
    }
}
</style>
